const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-assets/shared/auto-analysis/channels-auto-analysis");